import { ApiResponse, DocDotTask } from '../types'
import { apiService } from './api.service'

export interface TaskQueryParams {
  task_id?: string
  page?: number
  page_size?: number
  ordering?: string
  status?: string
  task_name?: string
  acknowledged?: boolean
  search?: string
  task_file_name__icontains?: string
  result__icontains?: string
}

class TaskService {
  async getTasksPage(params?: TaskQueryParams): Promise<ApiResponse<DocDotTask>> {
    const response = await apiService.get<ApiResponse<DocDotTask>>('tasks/', {
      params,
    })
    return response.data
  }

  // Compatibility helper for existing callers that expect plain array.
  async getTasks(params?: TaskQueryParams): Promise<DocDotTask[]> {
    const response = await this.getTasksPage(params)
    return response.results || []
  }

  async dismissTasks(taskIds: number[]): Promise<void> {
    await apiService.post('tasks/acknowledge/', {
      tasks: taskIds,
    })
  }

  async runTask(taskName: string): Promise<void> {
    await apiService.post('tasks/run/', {
      task_name: taskName,
    })
  }

  // Helper methods to get tasks by status
  // Uvek filtriramo po task_name=consume_file i acknowledged=false kao u React verziji
  async getQueuedTasks(): Promise<DocDotTask[]> {
    const tasks = await this.getTasks({
      task_name: 'consume_file',
      acknowledged: false,
    })
    return tasks.filter((t) => t.status === 'PENDING')
  }

  async getStartedTasks(): Promise<DocDotTask[]> {
    const tasks = await this.getTasks({
      task_name: 'consume_file',
      acknowledged: false,
    })
    return tasks.filter((t) => t.status === 'STARTED')
  }

  async getCompletedTasks(): Promise<DocDotTask[]> {
    const tasks = await this.getTasks({
      task_name: 'consume_file',
      acknowledged: false,
    })
    return tasks.filter((t) => t.status === 'SUCCESS')
  }

  async getFailedTasks(): Promise<DocDotTask[]> {
    const tasks = await this.getTasks({
      task_name: 'consume_file',
      acknowledged: false,
    })
    return tasks.filter((t) => t.status === 'FAILURE')
  }
}

export const taskService = new TaskService()
